import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

import { EntityList } from '../../objects/entity-list';
import { Site } from '../../objects/site';

// Angular Material Imports
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatButtonModule } from '@angular/material/button'; 
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatInputModule } from '@angular/material/input';

import { AgGridModule } from 'ag-grid-angular';

// Services
import { SiteService } from '../../service/entity-services/site.service';
import { SidenavContentService } from '../../service/sidenav-content.service';
import { ViewsService } from '../../service/views.service';

// Column definitions
import * as sitesColumns from '../../../app/shared/entity-columns/sites-columns';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-sites-list',
  templateUrl: './sites-list.component.html',
  styleUrls: ['./sites-list.component.css'],
  standalone: true,
  imports: [
    AsyncPipe,
    AgGridModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MatGridListModule,
    MatDividerModule,
    MatSidenavModule
  ]
})
export class SitesListComponent extends EntityList implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('sitesSidenavActions') sitesSidenavActions!: TemplateRef<any>;

  // Inject services using modern pattern
  private router = inject(Router);
  private sidenavContentService = inject(SidenavContentService);

  // Column definitions
  allColumns = sitesColumns.allColumns;
  
  defaultSiteViewCols = [
    sitesColumns.colSiteName,
    sitesColumns.colAddress,
    sitesColumns.colState,
    sitesColumns.colZip,
    sitesColumns.colBusUnitNum,
    sitesColumns.colDistrict,
    sitesColumns.colDivision,
    sitesColumns.colCounty,
    sitesColumns.colFormerlyKnownAs,
    sitesColumns.colSquareFootage,
    sitesColumns.colProgram,
    sitesColumns.colComments
  ];

  columnSelectList = sitesColumns.columnSelectList;

  // Filter states
  showInactiveSites = false;
  filteredSites: Site[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.titleService.setTitle('Sites');

    // Debug: Subscribe to allSites$ and log the data
    this.allSites$.subscribe(sites => {
      // console.log('🏢 Sites data received:', sites);
    });    
  }

  ngAfterViewInit(): void {
    // Send the template to the sidenav service
    this.sidenavContentService.updateSidenavContent(this.sitesSidenavActions);
  }

  ngOnDestroy(): void {
    // Clear the sidenav content when component is destroyed
    this.sidenavContentService.updateSidenavContent(null);
  }

  // Grid event handlers
  onCellClicked(event: any) {
    console.log('Site clicked:', event.data);
    console.log('Site number:', event.data.siteNum);

    // Navigate to individual site view
    this.router.navigate(['/securehome/site', event.data.siteNum]);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.columnApi = params.api;
  }

  // Navigation methods
  newSite() {
    console.log('Routing to new site form');
    this.router.navigateByUrl('/securehome/new-site');
  }

  // Filter and search methods
  findTextInTableData(filterValue: string) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(filterValue);
    }
  }

  toggleInactiveSites() {
    this.showInactiveSites = !this.showInactiveSites;
    // You can implement filtering logic here if needed
    // this.filterSitesByStatus();
  }

  // View management methods
  customizeColumns() {
    this.customizeColumnsUi = !this.customizeColumnsUi;
  }

  selectionChanged(event: any) {
    if (this.gridApi && this.columnApi) {
      this.gridApi.setColumnDefs(this.selectedCols);
      this.columnApi.setColumnState(this.selectedCols);
      this.fixColumnWidths();
    }
  }

  // View management methods (saveView, saveNamedViewNow, loadNamedView,
  // openSavedReportsDialog, openDeleteSavedViewsDialog, showSaveNamedView)
  // are inherited from EntityList base class

  // Export methods
  exportCSV() {
    if (this.gridApi) {
      this.gridApi.exportDataAsCsv({
        fileName: 'sites-export.csv'
      });
    }
  }

  exportExcel() {
    if (this.gridApi) {
      this.gridApi.exportDataAsExcel({
        fileName: 'sites-export.xlsx'
      });
    }
  }

  // Grid utility methods
  async fixColumnWidths() {
    const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    while (this.gridApi == undefined) {
      await delay(1000);
    }

    this.gridApi.sizeColumnsToFit();
  }
}